{
    "(save {highestYearlyDiscount}%)": "(prihranite {highestYearlyDiscount}%)",
    "{amount} days free": "{amount} dni brezplačno",
    "{amount} off": "{amount} popusta",
    "{amount} off for first {number} months.": "{amount} popusta za prvih {number} mesecev.",
    "{amount} off for first {period}.": "{amount} popusta za prvih {period}.",
    "{amount} off forever.": "{amount} popusta za vedno.",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_one": "",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_two": "",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_few": "",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "{buyerName} has gifted you a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "{discount}% discount": "{discount}% popusta",
    "{duration} membership": "",
    "{memberEmail} will no longer receive {newsletterName} newsletter.": "{memberEmail} ne bo več prejemal {newsletterName} novic.",
    "{memberEmail} will no longer receive emails when someone replies to your comments.": "{memberEmail} ne bo več prejemal e-pošte, ko nekdo odgovori na vaše komentarje.",
    "{memberEmail} will no longer receive this newsletter.": "{memberEmail} ne bo več prejemal teh novic.",
    "{memberEmail} will no longer receive updates & announcements.": "",
    "{months} month": "",
    "{months} months": "",
    "{months} months free": "",
    "{tierName} membership": "",
    "{trialDays} days free": "{trialDays} dni brezplačno",
    "{years} years": "",
    "+1 (123) 456-7890": "+386 1 234 56 78",
    "1 month": "",
    "1 month free": "",
    "1 year": "",
    "A gift, just for you": "",
    "Access your RSS feeds": "",
    "Account": "Račun",
    "Account details updated successfully": "Podatki o računu so bili uspešno posodobljeni",
    "Account settings": "Nastavitve računa",
    "Add a personal note": "",
    "Add a short note to go with your gift": "",
    "After a free trial ends, you will be charged the regular price for the tier you've chosen. You can always cancel before then.": "Po koncu brezplačnega preizkusa se vam zaračuna redna cena za izbran paket. Pred tem jo lahko vedno prekličete.",
    "Already a member?": "Ste že član?",
    "An error occurred": "Prišlo je do napake",
    "An unexpected error occured. Please try again or <a>contact support</a> if the error persists.": "Prišlo je do nepričakovane napake. Poskusite znova ali <a>kontaktirajte podporo</a>, če napaka vztraja.",
    "Back": "Nazaj",
    "Back to Log in": "Nazaj na prijavo",
    "Before you go": "",
    "Billing info & receipts": "",
    "Black Friday": "Črni petek",
    "Bluesky": "",
    "Buy": "",
    "Buying for someone else?": "",
    "Cancel anytime.": "Prekličite kadarkoli.",
    "Cancel subscription": "Prekliči naročnino",
    "Canceled": "",
    "Cancellation reason": "Razlog za preklic",
    "Change": "Spremeni",
    "Change plan": "Spremeni paket",
    "Check spam & promotions folders": "Preverite mapo za vsiljeno pošto in promocije",
    "Check with your mail provider": "Preverite pri svojem ponudniku e-pošte",
    "Check your inbox to verify email update": "Preverite svoj e-poštni nabiralnik, da potrdite posodobitev e-pošte",
    "Choose": "Izberite",
    "Choose a date from today onwards": "",
    "Choose a date within the next year": "",
    "Choose a delivery date": "",
    "Choose a different plan": "Izberite drug paket",
    "Choose a plan": "Izberite paket",
    "Choose a tier": "",
    "Choose your newsletters": "Izberite svoje novice",
    "Click here to retry": "Kliknite tukaj, da poskusite znova",
    "Click the confirmation link in your inbox to finish redeeming your membership. If it doesn't arrive within 3 minutes, check your spam folder.": "",
    "Close": "Zapri",
    "Code": "",
    "Comment preferences updated.": "Nastavitve komentarjev so bile posodobljene.",
    "Comments": "Komentarji",
    "Complimentary": "Promocijsko",
    "Confirm": "Potrdi",
    "Confirm cancellation": "Potrdi preklic",
    "Confirm subscription": "Potrdi naročnino",
    "Contact support": "Kontaktiraj podporo",
    "Continue": "Nadaljuj",
    "Continue subscription": "Nadaljuj naročnino",
    "Continue to delivery details": "",
    "Continue to payment": "",
    "Continue with a paid subscription anytime. Your remaining gift period will be added as a free trial.": "",
    "Copied": "",
    "Copy": "",
    "Copy link": "",
    "Could not create Stripe billing portal session": "",
    "Could not create Stripe checkout session": "Ni bilo mogoče ustvariti seje za Stripe checkout",
    "Could not sign in. Login link expired.": "Prijava ni uspela. Povezava za prijavo je potekla.",
    "Could not update email! Invalid link.": "Posodobitev e-pošte ni uspela! Neveljavna povezava.",
    "Create a new contact": "Ustvari nov stik",
    "Current plan": "Trenutni paket",
    "Delete account": "Izbriši račun",
    "Delivery date": "",
    "Delivery method": "",
    "Didn't mean to do this? Manage your preferences <button>here</button>.": "Niste želeli narediti tega? Upravljajte svoje nastavitve <button>tukaj</button>.",
    "Don't have an account?": "Nimate računa?",
    "Edit": "Uredi",
    "Email": "E-pošta",
    "Email confirmation link expired.": "",
    "Email it to them": "",
    "Email newsletter": "E-poštne novice",
    "Email newsletter settings updated": "Nastavitve e-poštnih novic so bile posodobljene",
    "Email preferences": "Nastavitve e-pošte",
    "Email preferences updated.": "Nastavitve e-pošte so bile posodobljene.",
    "Emails": "E-pošta",
    "Emails disabled": "E-pošta onemogočena",
    "Ends {offerEndDate}": "Poteče {offerEndDate}",
    "Enjoy {amountOff} off forever.": "",
    "Enjoy {months} free months on us.": "",
    "Enjoy {months} free months on us. You won't be charged until {newBillingDate}.": "",
    "Enjoy a free month on us.": "",
    "Enjoy a free month on us. You won't be charged until {newBillingDate}.": "",
    "Enter code above": "",
    "Enter the recipient's email address": "",
    "Enter your email address": "Vnesite svoj e-poštni naslov",
    "Enter your name": "Vnesite svoje ime",
    "Error": "Napaka",
    "Expires {expiryDate}": "Poteče {expiryDate}",
    "Facebook": "",
    "Failed to cancel subscription, please try again": "Preklic naročnine ni uspel, poskusite znova",
    "Failed to log in, please try again": "Prijava ni uspela, poskusite znova",
    "Failed to log out, please try again": "Odjava ni uspela, poskusite znova",
    "Failed to open billing portal, please try again": "",
    "Failed to process checkout, please try again": "Postopek nakupa ni uspel, poskusite znova",
    "Failed to send magic link email": "Ni bilo mogoče poslati e-pošte z magično povezavo",
    "Failed to send verification email": "Ni bilo mogoče poslati potrditvene e-pošte",
    "Failed to sign up, please try again": "Registracija ni uspela, poskusite znova",
    "Failed to update account data": "Posodobitev podatkov računa ni uspela",
    "Failed to update account details": "Posodobitev podrobnosti računa ni uspela",
    "Failed to update billing information, please try again": "",
    "Failed to update newsletter settings": "Posodobitev nastavitev novic ni uspela",
    "Failed to update subscription, please try again": "Posodobitev naročnine ni uspela, poskusite znova",
    "Failed to verify code, please try again": "",
    "For a friend or colleague": "",
    "Forever": "Za vedno",
    "Free Trial – Ends {trialEnd}": "Brezplačen preizkus – konča se {trialEnd}",
    "From": "",
    "Get help": "Pomoč",
    "Get in touch for help": "Kontaktirajte nas za pomoč",
    "Get notified when someone replies to your comment": "Prejmite obvestilo, ko nekdo odgovori na vaš komentar",
    "Gift a membership": "",
    "Gift could not be redeemed": "",
    "Gift details": "",
    "Gift duration": "",
    "Gift link copied to clipboard": "",
    "Gift membership": "",
    "Gift redeemed! You're all set.": "",
    "Gift subscription": "",
    "Gift subscriptions are not available right now.": "",
    "Gift value": "",
    "Give feedback on this post": "Podajte povratne informacije o tej objavi",
    "Help! I'm not receiving emails": "Pomoč! Ne prejemam e-pošte",
    "Here are a few other sites you may enjoy.": "Tukaj je nekaj drugih spletnih strani, ki vam bodo morda všeč.",
    "Hi {recipientName},": "",
    "Hide details": "",
    "How would you like to share this gift?": "",
    "I'll share it myself": "",
    "If a newsletter is flagged as spam, emails are automatically disabled for that address to make sure you no longer receive any unwanted messages.": "Če so novice označene kot vsiljena pošta, se e-pošta za ta naslov samodejno onemogoči, da zagotovo ne boste več prejemali neželenih sporočil.",
    "If the spam complaint was accidental, or you would like to begin receiving emails again, you can resubscribe to emails by clicking the button on the previous screen.": "Če je bila pritožba zaradi vsiljene pošte naključna ali želite ponovno prejemati e-pošto, se lahko ponovno prijavite na e-pošto z gumbom na prejšnjem zaslonu.",
    "If you cancel your subscription now, you will continue to have access until {periodEnd}.": "Če zdaj prekličete naročnino, boste imeli še vedno dostop do {periodEnd}.",
    "If you have a corporate or government email account, reach out to your IT department and ask them to allow emails to be received from {senderEmail}": "Če imate poslovni ali vladni e-poštni račun, se obrnite na svoj IT oddelek in jih prosite, naj omogočijo prejemanje e-pošte iz {senderEmail}.",
    "If you have an account, a login link has been sent to your inbox. If it doesn't arrive in 3 minutes, be sure to check your spam folder.": "Povezava za prijavo je bila poslana na vašo e-pošto. Če ne prispe v treh minutah, preverite mapo za vsiljeno pošto.",
    "If you have an account, an email has been sent to {submittedEmailOrInbox}. Click the link inside or enter your code below.": "",
    "If you would like to start receiving emails again, the best next steps are to check your email address on file for any issues and then click resubscribe on the previous screen.": "Če želite ponovno prejemati e-pošto, so najboljši naslednji koraki, da preverite svoj e-poštni naslov za morebitne težave in se nato ponovno naročite na prejšnjem zaslonu.",
    "If you're not receiving the email newsletter you've subscribed to, here are a few things to check.": "Če ne prejemate novic, na katere ste se naročili, je tukaj nekaj stvari, ki jih preverite.",
    "If you've completed all these checks and you're still not receiving emails, you can reach out to get support by contacting {supportAddress}.": "Če ste izvedli vse te preglede in še vedno ne prejemate e-pošte, se lahko obrnete na podporo prek {supportAddress}.",
    "In the event a permanent failure is received when attempting to send a newsletter, emails will be disabled on the account.": "Če pri pošiljanju e-novic pride do trajne napake, bo e-pošta na računu onemogočena.",
    "In your email client add {senderEmail} to your contacts list. This signals to your mail provider that emails sent from this address should be trusted.": "V svojem e-poštnem odjemalcu dodajte {senderEmail} na seznam stikov. To signalizira vašemu ponudniku e-pošte, da je e-pošta, poslana s tega naslova, zaupanja vredna.",
    "Invalid email address": "Neveljavna e-pošta",
    "Invalid verification code": "",
    "Jamie Larson": "Janez Novak",
    "jamie@example.com": "janez@primer.si",
    "Less like this": "Manj takšnih vsebin",
    "LinkedIn": "",
    "Make sure emails aren't accidentally ending up in the Spam or Promotions folders of your inbox. If they are, click on \"Mark as not spam\" and/or \"Move to inbox\".": "Prepričajte se, da e-pošta ne konča v mapi za vsiljeno pošto ali promocije. Če se to zgodi, kliknite na \"Ni vsiljena pošta\" in/ali \"Premakni v nabiralnik\".",
    "Manage": "Upravljanje",
    "Maybe later": "Morda kasneje",
    "Membership details": "",
    "Memberships from this email domain are currently restricted.": "",
    "Memberships unavailable, contact the owner for access.": "Članstva niso na voljo, obrnite se na lastnika za dostop.",
    "month": "mesec",
    "Monthly": "Mesečno",
    "More like this": "Več takšnih vsebin",
    "More options": "",
    "Name": "Ime",
    "Need more help? Contact support": "Potrebujete več pomoči? Obrnite se na podporo",
    "Newsletters can be disabled on your account for two reasons: A previous email was marked as spam, or attempting to send an email resulted in a permanent failure (bounce).": "E-poštne novice so na vašem računu lahko onemogočene iz dveh razlogov: prejšnja e-pošta je bila označeno kot vsiljena pošta ali pa je pri pošiljanju e-pošte prišlo do trajne napake (odboj).",
    "No member exists with this e-mail address.": "Član s tem e-poštnim naslovom ne obstaja.",
    "No thanks, I want to cancel": "",
    "Not ready to share? We've also emailed a copy to your inbox.": "",
    "Not receiving emails?": "Ne prejemate e-pošte",
    "Now": "",
    "Now check your email!": "Preverite svojo e-pošto!",
    "Occasional updates from {siteTitle}": "",
    "Once resubscribed, if you still don't see emails in your inbox, check your spam folder. Some inbox providers keep a record of previous spam complaints and will continue to flag emails. If this happens, mark the latest newsletter as 'Not spam' to move it back to your primary inbox.": "Ko boste ponovno naročeni in še vedno ne vidite e-pošte v svoji mapi Prejeto, preverite mapo za vsiljeno pošto. Nekateri ponudniki hranijo zgodovino prejšnjih pritožb zaradi vsiljene pošte in bodo še naprej označevali e-pošto. Če se to zgodi, označite najnovejše novice kot 'Ni vsiljena pošta', da jih premaknete nazaj v svojo glavno mapo Prejeto.",
    "Open AOL Mail": "",
    "Open email": "",
    "Open Feedbin": "",
    "Open Gmail": "",
    "Open Hey": "",
    "Open iCloud Mail": "",
    "Open Mail.ru": "",
    "Open Outlook": "",
    "Open Proton Mail": "",
    "Open Yahoo Mail": "",
    "Optional message": "",
    "Permanent failure (bounce)": "Trajna napaka (odboj)",
    "Phone number": "Telefonska številka",
    "Plan": "Paket",
    "Plan checkout was cancelled.": "Postopek nakupa paketa je bil preklican.",
    "Plan upgrade was cancelled.": "Nadgradnja paketa je bila preklicana.",
    "Please contact {supportAddress} to adjust your complimentary subscription.": "Obrnite se na {supportAddress}, da prilagodite svojo promocijsko naročnino.",
    "Please enter {fieldName}": "Vnesite {fieldName}",
    "Please fill in required fields": "Izpolnite potrebna polja",
    "Podcasts": "",
    "Re-enable emails": "Ponovno omogočite e-pošto",
    "Recipient's email": "",
    "Recipient's name": "",
    "Recommendations": "Priporočila",
    "Redeem your gift": "",
    "Redeeming...": "",
    "Renews at {price}.": "Obnovi se za {price}.",
    "Resume subscription": "",
    "Retry": "Poskusi znova",
    "Save": "Shrani",
    "Save {amountOff} on your next {durationInMonths} billing cycles. Then {currency}{originalPrice}/{cadence}.": "",
    "Save {amountOff} on your next billing cycle. Then {currency}{originalPrice}/{cadence}.": "",
    "Send the link below to share it with whoever you'd like.": "",
    "Sending login link...": "Pošiljanje povezave za prijavo...",
    "Sending...": "Pošiljanje...",
    "Share": "",
    "Share a full membership to {siteTitle} with a friend or colleague": "",
    "Share it yourself": "",
    "Show all": "Pokaži vse",
    "Sign in": "Prijava",
    "Sign out": "Odjava",
    "Sign up": "Registracija",
    "Signup error: Invalid link": "Napaka pri registraciji: Neveljavna povezava",
    "Signups from this email domain are currently restricted.": "Prijave iz te e-pošte so trenutno omejene.",
    "Something went wrong, please try again later.": "Nekaj je šlo narobe, poskusite ponovno kasneje.",
    "Sorry, no paid plans are available.": "",
    "Sorry, no recommendations are available right now.": "Oprostite, trenutno ni priporočil.",
    "Sorry, that didn’t work.": "Oprostite, to ni uspelo.",
    "Spam complaints": "Pritožbe zaradi vsiljene pošte",
    "Start {amount}-day free trial": "Začnite {amount}-dnevni brezplačni preizkus",
    "Starting {startDate}": "Začetek {startDate}",
    "Starting today": "Z današnjim dnem",
    "Submit feedback": "Pošljite povratne informacije",
    "Subscribe": "Naročite se",
    "Subscribed": "Naročen",
    "Subscription plan updated successfully": "Naročniški paket je bil uspešno posodobljen",
    "Success": "Uspeh",
    "Success! Check your email for magic link to sign-in.": "Uspeh! Preverite svojo e-pošto za čarobno povezavo za prijavo.",
    "Success! Your account is fully activated, you now have access to all content.": "Uspeh! Vaš račun je popolnoma aktiviran, zdaj imate dostop do vseh vsebin.",
    "Success! Your email is updated.": "Uspeh! Vaš e-poštni naslov je posodobljen.",
    "Successfully unsubscribed": "Uspešno ste se odjavili",
    "Taylor Reid": "",
    "taylor@example.com": "",
    "Thank you for subscribing. Before you start reading, below are a few other sites you may enjoy.": "Hvala, da ste se naročili. Preden začnete brati, so tukaj še nekatera druga spletna mesta, ki vam bodo morda všeč.",
    "Thank you for your support": "Hvala za vašo podporo",
    "Thank you for your support!": "Hvala za vašo podporo!",
    "Thanks for the feedback!": "Hvala za povratne informacije!",
    "That didn't go to plan": "To ni šlo po načrtu",
    "The email address we have for you is {memberEmail} — if that's not correct, you can update it in your <button>account settings area</button>.": "E-poštni naslov, ki ga imamo za vas, je {memberEmail} — če ni pravilen, ga lahko posodobite v svojih <button>nastavitvah računa</button>.",
    "There was a problem submitting your feedback. Please try again a little later.": "Prišlo je do težave pri oddaji vaših povratnih informacij. Ponovno poskusite malo kasneje.",
    "There was an error cancelling your subscription, please try again.": "Prišlo je do napake pri preklicu vaše naročnine, prosimo, poskusite znova.",
    "There was an error continuing your subscription, please try again.": "Prišlo je do napake pri nadaljevanju vaše naročnine, prosimo, poskusite znova.",
    "There was an error processing your payment. Please try again.": "Prišlo je do napake pri obdelavi vaše plačljive transakcije. Prosimo, poskusite znova.",
    "There was an error sending the email, please try again": "Prišlo je do napake pri pošiljanju e-pošte, prosimo, poskusite znova",
    "This gift can only be redeemed once and expires on {expiryDate}.": "",
    "This gift has already been consumed.": "",
    "This gift has already been redeemed.": "",
    "This gift has been refunded.": "",
    "This gift has expired.": "",
    "This gift link is invalid.": "",
    "This site is invite-only, contact the owner for access.": "To spletno mesto je dostopno samo s povabilom, obrnite se na lastnika.",
    "This site is not accepting donations at the moment.": "",
    "This site is not accepting payments at the moment.": "To spletno mesto trenutno ne sprejema plačil.",
    "This site only accepts paid members.": "To spletno mesto sprejema samo plačljive člane.",
    "This unsubscribe link belongs to a different email address than the one you are signed in with.": "",
    "Threads": "",
    "Tier": "",
    "To": "",
    "To complete signup, click the confirmation link in your inbox. If it doesn't arrive within 3 minutes, check your spam folder!": "Za dokončanje prijave kliknite potrditveno povezavo v vaši e-pošti. Če ne prispe v 3 minutah, preverite mapo za neželeno pošto!",
    "To continue to stay up to date, subscribe to {publication} below.": "Če želite ostati na tekočem, se spodaj naročite na {publication}.",
    "Too many attempts try again in {number} days.": "Preveč poskusov, poskusite znova čez {number} dni.",
    "Too many attempts try again in {number} hours.": "Preveč poskusov, poskusite znova čez {number} ur.",
    "Too many attempts try again in {number} minutes.": "Preveč poskusov, poskusite znova čez {number} minut.",
    "Too many different sign-in attempts, try again in {number} days": "Preveč različnih poskusov prijave, poskusite znova čez {number} dni.",
    "Too many different sign-in attempts, try again in {number} hours": "Preveč različnih poskusov prijave, poskusite znova čez {number} ur.",
    "Too many different sign-in attempts, try again in {number} minutes": "Preveč različnih poskusov prijave, poskusite znova čez {number} minut.",
    "Too many sign-up attempts, try again later": "Preveč različnih poskusov prijave, poskusite znova kasneje.",
    "Try free for {amount} days, then {originalPrice}.": "Preizkusite brezplačno za {amount} dni, nato pa za {originalPrice}.",
    "Unable to initiate checkout session": "Ni mogoče začeti seje zaključka nakupa.",
    "Unlock access to all newsletters by becoming a paid subscriber.": "Odkleni dostop do vseh novic s plačljivo naročnino.",
    "Unsubscribe from all emails": "Odjava od vse e-pošte",
    "Unsubscribed": "Odjavljen",
    "Unsubscribed from all emails.": "Odjavljen od vse e-pošte.",
    "Unsubscribing from emails will not cancel your paid subscription to {title}": "Odjava od e-pošte ne bo preklicala vaše plačljive naročnine na {title}.",
    "Update": "Posodobi",
    "Update your preferences": "Posodobite svoje nastavitve",
    "Updates & announcements": "",
    "Verification link sent, check your inbox": "Povezava je bila poslana, preverite svojo e-pošto",
    "Verify your email address is correct": "Preverite, da je vaš e-poštni naslov pravilen",
    "Verifying...": "",
    "View plans": "Ogled paketov",
    "We couldn't unsubscribe you as the email address was not found. Please contact the site owner.": "Nismo vas mogli odjaviti, ker e-poštnega naslova nismo našli. Prosimo, obrnite se na lastnika spletnega mesta.",
    "We'd hate to see you leave. How about a special offer to stay?": "",
    "We'll email it to the recipient on {deliveryDate}. A copy is in your inbox too.": "",
    "We'll email it to the recipient. A copy will be in your inbox too.": "",
    "Welcome back, {name}!": "Dobrodošli nazaj, {name}!",
    "Welcome back!": "Dobrodošli nazaj!",
    "Welcome to {siteTitle}": "Dobrodošli na {siteTitle}",
    "What's included": "",
    "When an inbox fails to accept an email it is commonly called a bounce. In many cases, this can be temporary. However, in some cases, a bounced email can be returned as a permanent failure when an email address is invalid or non-existent.": "Ko mapa za prejeto ne sprejme e-pošte, se to običajno imenuje 'odboj'. V mnogih primerih je to lahko začasno. Vendar pa lahko v nekaterih primerih e-pošta, ki je bila odbita, vrne trajno napako, kadar je e-poštni naslov neveljaven ali neobstoječ.",
    "Why has my email been disabled?": "Zakaj je bil moj e-poštni naslov onemogočen?",
    "X (Twitter)": "",
    "year": "leto",
    "Yearly": "Letno",
    "You already have an active subscription.": "",
    "You currently have a free membership, upgrade to a paid subscription for full access.": "Trenutno imate brezplačno članstvo, za poln dostop nadgradite na plačljivo naročnino.",
    "You have been successfully resubscribed": "Uspešno ste se ponovno naročili",
    "You now have access to {tierName} until {expiryDate}. Enjoy!": "",
    "You're currently not receiving emails": "Trenutno ne prejemate e-pošte",
    "You're not receiving emails": "Ne prejemate e-pošte",
    "You're not receiving emails because you either marked a recent message as spam, or because messages could not be delivered to your provided email address.": "Ne prejemate e-pošte, ker ste naše sporočilo nedavno označili kot vsiljeno pošto ali, ker sporočil ni bilo mogoče dostaviti na vaš e-poštni naslov.",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_one": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_two": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_few": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_other": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_one": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_two": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_few": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "You've successfully signed in.": "Uspešno ste se prijavili.",
    "You've successfully subscribed to <strong>{siteTitle}</strong>": "Uspešno ste se naročili na <strong>{siteTitle}</strong>",
    "Your account": "Vaš račun",
    "Your email": "",
    "Your email has failed to resubscribe, please try again": "Vašega e-poštnega naslova nismo uspeli ponovno prijaviti, prosimo, poskusite znova",
    "Your gift is on its way": "",
    "Your gift is ready": "",
    "Your gift is scheduled": "",
    "Your gift subscription will expire on {expiryDate}": "",
    "your inbox": "",
    "Your input helps shape what gets published.": "Vaše mnenje nam pomaga pri izbiri objavljenih vsebin.",
    "Your name": "",
    "Your subscription has been canceled and will expire on {expiryDate}.": "",
    "Your subscription will expire on {expiryDate}": "Vaša naročnina bo potekla dne {expiryDate}",
    "Your subscription will renew on {renewalDate}": "Vaša naročnina se bo obnovila dne {renewalDate}",
    "Your subscription will start on {subscriptionStart}": "Vaša naročnina se začne dne {subscriptionStart}"
}
